module.exports = __webpack_public_path__ + "static/media/logo-assine.1612deff.png";